import {NavigateFunction} from 'react-router-dom';
import {IError, ISuccess} from '../helpers/types';
import {IOption} from '../fields/types';

export interface IStateApp {
    loading: boolean;
    errorReq: IError | null;
    successReq: ISuccess | null;
    resetSuccess: boolean;
    backendAvailable: boolean;
    token: IToken | null;
    expires_at: string | null;
    brands: IOption[];
    carBrands: IOption[];
    brandsTotal: number,
    carBrandsTotal: number,
    order_by: {
        key: string | null;
        direction: string | null;
    }
}

export interface IToken {
    token_type: string;
    token: string;
    expires_at: string;
}

export interface ITokenRes {
    token: IToken;
    expires_at: string;
}


export interface IRegistrationProps {
    email: string;
    full_name: string;
    password: string;
    region: number | string;
    city: number | string;
    invite_code?: string;
    navigate: NavigateFunction;
}

export interface ILoginProps {
    login: string;
    password: string;
    remember_me: boolean;
    navigateAfterLogin?: string;
}

export interface IUpdatePasswordProps {
    login: string;
    password: string;
    token: string;
    navigate: NavigateFunction;
}

export const alertTypes = {
    INFO: 'info',
    SUCCESS: 'success',
    ERROR: 'error'
};

export interface IAlert {
    type: string;
    text: string;
}
